import { MoneyType, SuitesType } from '@api';
import {
  formatCurrency,
  formatNumber,
  getValueByPath,
  TouringCardTableRow,
  TouringCardTableRowLabel,
  TouringCardTableRowValue,
} from '@common';
import { useTranslation } from 'react-i18next';
import { VenueSuitesTableRowType } from '../../data';

type VenueSuitesTableRowPropsType = {
  venueSuites: SuitesType;
  row: VenueSuitesTableRowType;
};
export const VenueSuitesTableRow: React.FC<VenueSuitesTableRowPropsType> = ({
  venueSuites,
  row,
}) => {
  const { t } = useTranslation('venueDetailsOverview');

  const label = t(`VENUE_SUITES.ROWS.${row.label}`);
  const value = getValueByPath(venueSuites, row.accessor);

  const getRenderValue = () => {
    if (!value) return t('NO_DATA_PLACEHOLDER', { ns: 'common' });

    switch (row.accessor) {
      case 'seats':
        return formatNumber(Number(value));
      case 'uplift':
      case 'share':
        return formatCurrency(value as MoneyType);
      case 'notes':
        return String(value);
    }
  };
  return (
    <TouringCardTableRow>
      <TouringCardTableRowLabel>{label}</TouringCardTableRowLabel>
      <TouringCardTableRowValue>{getRenderValue()}</TouringCardTableRowValue>
    </TouringCardTableRow>
  );
};
